<template>
  <base-modal
      :close-on-confirm="false"
      :discarding-disabled="!message.length || sending"
      :discarding-offered="true"
      :confirmation-disabled="!message.length || sending || sendAttempted"
      :confirmation-finished="this.sendAttempted"
      :confirmation-required="true"
      :confirmation-succeeded="this.sendSuccessful"
      :default-height="true"
      :modal-name="this.$options.name"
      :text-confirm="textConfirm"
      :text-confirm-clicked="textConfirm"
      :confirm-error="sendError"
      :text-discard="textDiscard"
      @confirm="sendMessage"
      @before-close="beforeClose"
      :length="515"
      :body-gap="10"
      icon-modal="feedback"
      modal-title="Give feedback or report a problem"
      text-confirm-error="Sending failed. Try again later."
      text-confirm-success="Message sent. Thanks!"
  >
    <template #body>
      <div class="report-input">
        <div class="input-header">Message</div>
        <textarea v-model="message" :disabled="sending || sendAttempted" class="message" maxlength="5000"
                  placeholder="Please write your message to us here..."></textarea>

        <div class="input-header">Your email address (optional)</div>
        <textarea v-model="email" :disabled="sending || sendAttempted" class="email" maxlength="200"
                  placeholder="If you provide your email address we can notify you when your issue is fixed."></textarea>
        <div class="consent">
        <span><b>Reporting a problem?</b> Please also <b>submit your selected preferences</b> when the problem occurred and
         which <b>browser</b> you used (then we can fix the problem more easily).</span>
          <label class="consent-item">
            <input v-model="consentData" :disabled="sending || sendAttempted" type="checkbox">
            <span>Submit my <b>selected preferences</b> </span>
          </label>
          <label class="consent-item">
            <input v-model="consentMetaData" :disabled="sending || sendAttempted" type="checkbox">
            <span>Submit my <b>browser</b> name and version</span>
          </label>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>

import BaseModal from "@/components/modals/BaseModal.vue";

export default {
  name: "ReportModal",
  components: {BaseModal},
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      message: "",
      email: "",
      consentData: false,
      consentMetaData: false,
      sending: false,
      sendAttempted: false,
      sendSuccessful: null,
      sendError: false,
    }
  },
  computed: {
    textDiscard() {
      return this.sendAttempted ? "Close" : "Discard";
    },
    textConfirm() {
      if (this.sendError) return "Sending failed. Try again later.";
      return this.sending ? "Sending..." : "Send";
    },
  },
  methods: {
    beforeClose() {
      this.cleanModal();
    },
    cleanModal() {
      this.message = "";
      this.email = "";
      this.consentData = false;
      this.consentMetaData = false;
      this.sending = false;
      this.sendAttempted = false;
      this.sendSuccessful = false;
      this.sendError = false;
    },
    async sendMessage() {
      this.sending = true;
      this.sendError = false;
      try {
        this.sendSuccessful = await this.$store.dispatch("sendReport", {
          email: this.email,
          message: this.message,
          consentData: this.consentData,
          consentMetaData: this.consentMetaData
        });
        if (this.sendSuccessful) {
          this.sendAttempted = true;
        } else {
          this.sendError = true;
        }
      } catch (error) {
        this.sendSuccessful = false;
        this.sendError = true;
      } finally {
        this.sending = false;
      }
    }
  }
};
</script>

<style scoped>
.report-input {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 15px;
}

.email {
  border: 1px dashed #bbb;
  border-radius: 4px;
  padding: 10px;
  overflow-x: auto;
  overflow-y: clip;
  resize: none;
  line-height: 1.5;
  flex: 0.1;
}

.email:focus {
  outline: none;
}

.message {
  border: 1px dashed #bbb;
  border-radius: 4px;
  padding: 10px;
  overflow-y: auto;
  resize: none;
  line-height: 1.5;
  flex: 1;
}

.message:focus {
  outline: none;
}

.consent {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.consent-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 90%;
  line-height: 1.5;
}

.consent-item input {
  margin-left: 0;
}

input[type="checkbox"] {
  cursor: pointer;
}

.input-header {
  font-weight: bold;
  font-size: 90%;
  margin-bottom: -10px;
}

.error-message {
  color: #D95117;
  font-size: 90%;
  padding: 5px;
  background-color: #fbe9e7;
  border: 1px solid #ffccbc;
  border-radius: 4px;
}
</style>
